// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   SUBNET CALCULATOR - PREMIUM UI
========================================== */

.premium-subnet {
    width: 100%;
    padding: 25px !important;
    background: linear-gradient(145deg, #111827, #0b1220);
    border: 1px solid rgba(56,189,248,.15);
    border-radius: 16px;
    color: #e2e8f0;
    box-shadow: 0 12px 35px rgba(0,0,0,.20);
    font-family: Inter, Arial, sans-serif;
}

/* HEADER */

.subnet-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(148,163,184,.13);
}

.subnet-heading {
    display: flex;
    align-items: center;
    gap: 13px;
}

.subnet-icon {
    width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(14,165,233,.12);
    border: 1px solid rgba(56,189,248,.2);
    border-radius: 12px;
    font-size: 22px;
}

.subnet-heading h4 {
    margin: 0;
    color: #f8fafc;
    font-size: 19px;
    font-weight: 700;
}

.subnet-heading p {
    margin: 5px 0 0;
    color: #94a3b8;
    font-size: 11px;
}

.subnet-badge {
    padding: 8px 12px;
    color: #38bdf8;
    background: rgba(14,165,233,.09);
    border: 1px solid rgba(56,189,248,.2);
    border-radius: 20px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
}

/* SEARCH */

.subnet-search {
    padding: 24px 0;
}

.subnet-search label {
    display: block;
    margin-bottom: 10px;
    color: #94a3b8;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
}

.subnet-search .input-group {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: stretch;
    gap: 10px;
    padding: 7px;
    background: #080f1c;
    border: 1px solid #334155;
    border-radius: 11px;
    transition: .25s;
}

.subnet-search .input-group:focus-within {
    border-color: #0ea5e9;
    box-shadow: 0 0 0 3px rgba(14,165,233,.12);
}

/* INPUT FIELD */

.premium-subnet .input-group .form-control {
    display: block !important;
    flex: 1 1 !important;
    width: 1% !important;
    min-width: 0 !important;
    height: 44px;
    padding: 0 14px;
    background: transparent !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    color: #f1f5f9 !important;
    font-size: 14px;
}

.premium-subnet .form-control::placeholder {
    color: #64748b !important;
}

/* BUTTON */

.subnet-search .btn {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 115px;
    height: 44px;
    padding: 0 22px;
    border: none;
    border-radius: 8px !important;
    background: linear-gradient(135deg,#0284c7,#2563eb);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    transition: .25s;
}

.subnet-search .btn:hover:not(:disabled) {
    background: linear-gradient(135deg,#0ea5e9,#3b82f6);
    transform: translateY(-1px);
    box-shadow: 0 5px 15px rgba(14,165,233,.25);
}

.subnet-search .btn:disabled {
    opacity: .6;
    cursor: not-allowed;
}

.subnet-search > small {
    display: block;
    margin-top: 10px;
    color: #64748b;
    font-size: 11px;
}

/* RESULTS */

.subnet-results {
    margin-top: 5px;
    animation: subnetAppear .35s ease;
}

@keyframes subnetAppear {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* RESULT HEADER */

.subnet-result-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 17px;
}

.subnet-result-heading h5 {
    margin: 0;
    color: #f1f5f9;
    font-size: 15px;
    font-weight: 700;
}

.subnet-result-heading p {
    margin: 5px 0 0;
    color: #64748b;
    font-size: 11px;
}

.subnet-success {
    padding: 7px 11px;
    color: #4ade80;
    background: rgba(34,197,94,.09);
    border: 1px solid rgba(34,197,94,.2);
    border-radius: 20px;
    font-size: 9px;
    font-weight: 700;
}

/* RESULT GRID */

.subnet-grid {
    display: grid;
    grid-template-columns: repeat(3,minmax(0,1fr));
    gap: 13px;
}

.subnet-card {
    position: relative;
    min-width: 0;
    padding: 18px;
    background: #0b1423;
    border: 1px solid rgba(148,163,184,.13);
    border-radius: 11px;
    overflow: hidden;
    transition: .25s ease;
}

.subnet-card:hover {
    transform: translateY(-3px);
    border-color: rgba(56,189,248,.35);
    box-shadow: 0 8px 20px rgba(0,0,0,.15);
}

.subnet-card-icon {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    background: rgba(56,189,248,.09);
    border-radius: 9px;
    font-size: 17px;
}

.subnet-card > span {
    display: block;
    margin-bottom: 9px;
    color: #64748b;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .8px;
}

.subnet-card > strong {
    display: block;
    color: #bae6fd;
    font-size: 15px;
    font-weight: 700;
    overflow-wrap: anywhere;
}

.subnet-card > small {
    display: block;
    margin-top: 6px;
    color: #64748b;
    font-size: 10px;
}

/* CARD ACCENTS */

.network-card {
    border-top: 2px solid #0ea5e9;
}

.mask-card {
    border-top: 2px solid #8b5cf6;
}

.broadcast-card {
    border-top: 2px solid #f59e0b;
}

.hosts-card {
    border-top: 2px solid #22c55e;
}

.total-card {
    border-top: 2px solid #06b6d4;
}

.hosts-card > strong {
    color: #4ade80;
    font-size: 25px;
}

.total-card > strong {
    color: #22d3ee;
    font-size: 25px;
}

/* IP RANGE */

.subnet-range-card {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 15px;
    padding: 20px;
    background: linear-gradient(110deg,rgba(14,165,233,.12),rgba(37,99,235,.08));
    border: 1px solid rgba(56,189,248,.2);
    border-radius: 11px;
}

.range-icon {
    width: 42px;
    height: 42px;
    min-width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(14,165,233,.15);
    border-radius: 10px;
    color: #38bdf8;
    font-size: 25px;
}

.subnet-range-card div:last-child {
    min-width: 0;
}

.subnet-range-card span {
    display: block;
    margin-bottom: 7px;
    color: #94a3b8;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
}

.subnet-range-card strong {
    display: block;
    color: #7dd3fc;
    font-size: 16px;
    font-weight: 700;
    overflow-wrap: anywhere;
}

/* FOOTER */

.subnet-footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
    padding-top: 14px;
    border-top: 1px solid rgba(148,163,184,.12);
    color: #475569;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
}

/* RESPONSIVE */

@media(max-width: 900px) {
    .subnet-grid {
        grid-template-columns: repeat(2,minmax(0,1fr));
    }
}

@media(max-width: 576px) {
    .premium-subnet {
        padding: 15px !important;
    }

    .subnet-heading h4 {
        font-size: 16px;
    }

    .subnet-grid {
        grid-template-columns: 1fr;
    }

    .subnet-card {
        padding: 15px;
    }

    .subnet-range-card {
        padding: 14px;
    }

    .subnet-range-card strong {
        font-size: 13px;
    }

    .subnet-search .btn {
        min-width: 90px;
        padding: 0 12px;
        font-size: 11px;
    }

    .premium-subnet .input-group .form-control {
        font-size: 12px;
        padding: 0 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/SubnetCalc.css"],"names":[],"mappings":"AAAA;;4CAE4C;;AAE5C;IACI,WAAW;IACX,wBAAwB;IACxB,qDAAqD;IACrD,sCAAsC;IACtC,mBAAmB;IACnB,cAAc;IACd,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,qCAAqC;IACrC,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,WAAW;;AAEX;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,oBAAoB;IACpB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA,gBAAgB;;AAEhB;IACI,yBAAyB;IACzB,oBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,WAAW;;AAEX;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,mDAAmD;IACnD,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;IACnD,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,YAAY;;AAEZ;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,kBAAkB;;AAElB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,+BAA+B;IAC/B,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;IACb,8CAA8C;IAC9C,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA,iBAAiB;;AAEjB;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,aAAa;;AAEb;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,4EAA4E;IAC5E,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,eAAe;;AAEf;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;AACJ","sourcesContent":["/* ==========================================\n   SUBNET CALCULATOR - PREMIUM UI\n========================================== */\n\n.premium-subnet {\n    width: 100%;\n    padding: 25px !important;\n    background: linear-gradient(145deg, #111827, #0b1220);\n    border: 1px solid rgba(56,189,248,.15);\n    border-radius: 16px;\n    color: #e2e8f0;\n    box-shadow: 0 12px 35px rgba(0,0,0,.20);\n    font-family: Inter, Arial, sans-serif;\n}\n\n/* HEADER */\n\n.subnet-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 15px;\n    flex-wrap: wrap;\n    padding-bottom: 20px;\n    border-bottom: 1px solid rgba(148,163,184,.13);\n}\n\n.subnet-heading {\n    display: flex;\n    align-items: center;\n    gap: 13px;\n}\n\n.subnet-icon {\n    width: 46px;\n    height: 46px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(14,165,233,.12);\n    border: 1px solid rgba(56,189,248,.2);\n    border-radius: 12px;\n    font-size: 22px;\n}\n\n.subnet-heading h4 {\n    margin: 0;\n    color: #f8fafc;\n    font-size: 19px;\n    font-weight: 700;\n}\n\n.subnet-heading p {\n    margin: 5px 0 0;\n    color: #94a3b8;\n    font-size: 11px;\n}\n\n.subnet-badge {\n    padding: 8px 12px;\n    color: #38bdf8;\n    background: rgba(14,165,233,.09);\n    border: 1px solid rgba(56,189,248,.2);\n    border-radius: 20px;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n/* SEARCH */\n\n.subnet-search {\n    padding: 24px 0;\n}\n\n.subnet-search label {\n    display: block;\n    margin-bottom: 10px;\n    color: #94a3b8;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n.subnet-search .input-group {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    align-items: stretch;\n    gap: 10px;\n    padding: 7px;\n    background: #080f1c;\n    border: 1px solid #334155;\n    border-radius: 11px;\n    transition: .25s;\n}\n\n.subnet-search .input-group:focus-within {\n    border-color: #0ea5e9;\n    box-shadow: 0 0 0 3px rgba(14,165,233,.12);\n}\n\n/* INPUT FIELD */\n\n.premium-subnet .input-group .form-control {\n    display: block !important;\n    flex: 1 1 0% !important;\n    width: 1% !important;\n    min-width: 0 !important;\n    height: 44px;\n    padding: 0 14px;\n    background: transparent !important;\n    border: none !important;\n    outline: none !important;\n    box-shadow: none !important;\n    color: #f1f5f9 !important;\n    font-size: 14px;\n}\n\n.premium-subnet .form-control::placeholder {\n    color: #64748b !important;\n}\n\n/* BUTTON */\n\n.subnet-search .btn {\n    flex: 0 0 auto !important;\n    width: auto !important;\n    min-width: 115px;\n    height: 44px;\n    padding: 0 22px;\n    border: none;\n    border-radius: 8px !important;\n    background: linear-gradient(135deg,#0284c7,#2563eb);\n    color: #fff;\n    font-size: 13px;\n    font-weight: 700;\n    transition: .25s;\n}\n\n.subnet-search .btn:hover:not(:disabled) {\n    background: linear-gradient(135deg,#0ea5e9,#3b82f6);\n    transform: translateY(-1px);\n    box-shadow: 0 5px 15px rgba(14,165,233,.25);\n}\n\n.subnet-search .btn:disabled {\n    opacity: .6;\n    cursor: not-allowed;\n}\n\n.subnet-search > small {\n    display: block;\n    margin-top: 10px;\n    color: #64748b;\n    font-size: 11px;\n}\n\n/* RESULTS */\n\n.subnet-results {\n    margin-top: 5px;\n    animation: subnetAppear .35s ease;\n}\n\n@keyframes subnetAppear {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* RESULT HEADER */\n\n.subnet-result-heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 17px;\n}\n\n.subnet-result-heading h5 {\n    margin: 0;\n    color: #f1f5f9;\n    font-size: 15px;\n    font-weight: 700;\n}\n\n.subnet-result-heading p {\n    margin: 5px 0 0;\n    color: #64748b;\n    font-size: 11px;\n}\n\n.subnet-success {\n    padding: 7px 11px;\n    color: #4ade80;\n    background: rgba(34,197,94,.09);\n    border: 1px solid rgba(34,197,94,.2);\n    border-radius: 20px;\n    font-size: 9px;\n    font-weight: 700;\n}\n\n/* RESULT GRID */\n\n.subnet-grid {\n    display: grid;\n    grid-template-columns: repeat(3,minmax(0,1fr));\n    gap: 13px;\n}\n\n.subnet-card {\n    position: relative;\n    min-width: 0;\n    padding: 18px;\n    background: #0b1423;\n    border: 1px solid rgba(148,163,184,.13);\n    border-radius: 11px;\n    overflow: hidden;\n    transition: .25s ease;\n}\n\n.subnet-card:hover {\n    transform: translateY(-3px);\n    border-color: rgba(56,189,248,.35);\n    box-shadow: 0 8px 20px rgba(0,0,0,.15);\n}\n\n.subnet-card-icon {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 14px;\n    background: rgba(56,189,248,.09);\n    border-radius: 9px;\n    font-size: 17px;\n}\n\n.subnet-card > span {\n    display: block;\n    margin-bottom: 9px;\n    color: #64748b;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: .8px;\n}\n\n.subnet-card > strong {\n    display: block;\n    color: #bae6fd;\n    font-size: 15px;\n    font-weight: 700;\n    overflow-wrap: anywhere;\n}\n\n.subnet-card > small {\n    display: block;\n    margin-top: 6px;\n    color: #64748b;\n    font-size: 10px;\n}\n\n/* CARD ACCENTS */\n\n.network-card {\n    border-top: 2px solid #0ea5e9;\n}\n\n.mask-card {\n    border-top: 2px solid #8b5cf6;\n}\n\n.broadcast-card {\n    border-top: 2px solid #f59e0b;\n}\n\n.hosts-card {\n    border-top: 2px solid #22c55e;\n}\n\n.total-card {\n    border-top: 2px solid #06b6d4;\n}\n\n.hosts-card > strong {\n    color: #4ade80;\n    font-size: 25px;\n}\n\n.total-card > strong {\n    color: #22d3ee;\n    font-size: 25px;\n}\n\n/* IP RANGE */\n\n.subnet-range-card {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-top: 15px;\n    padding: 20px;\n    background: linear-gradient(110deg,rgba(14,165,233,.12),rgba(37,99,235,.08));\n    border: 1px solid rgba(56,189,248,.2);\n    border-radius: 11px;\n}\n\n.range-icon {\n    width: 42px;\n    height: 42px;\n    min-width: 42px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(14,165,233,.15);\n    border-radius: 10px;\n    color: #38bdf8;\n    font-size: 25px;\n}\n\n.subnet-range-card div:last-child {\n    min-width: 0;\n}\n\n.subnet-range-card span {\n    display: block;\n    margin-bottom: 7px;\n    color: #94a3b8;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n.subnet-range-card strong {\n    display: block;\n    color: #7dd3fc;\n    font-size: 16px;\n    font-weight: 700;\n    overflow-wrap: anywhere;\n}\n\n/* FOOTER */\n\n.subnet-footer {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 20px;\n    padding-top: 14px;\n    border-top: 1px solid rgba(148,163,184,.12);\n    color: #475569;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n/* RESPONSIVE */\n\n@media(max-width: 900px) {\n    .subnet-grid {\n        grid-template-columns: repeat(2,minmax(0,1fr));\n    }\n}\n\n@media(max-width: 576px) {\n    .premium-subnet {\n        padding: 15px !important;\n    }\n\n    .subnet-heading h4 {\n        font-size: 16px;\n    }\n\n    .subnet-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .subnet-card {\n        padding: 15px;\n    }\n\n    .subnet-range-card {\n        padding: 14px;\n    }\n\n    .subnet-range-card strong {\n        font-size: 13px;\n    }\n\n    .subnet-search .btn {\n        min-width: 90px;\n        padding: 0 12px;\n        font-size: 11px;\n    }\n\n    .premium-subnet .input-group .form-control {\n        font-size: 12px;\n        padding: 0 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
